/**
 * @date: 12/10/20
 * @author: Yan Wang <ywang@max.md>
 * @copy: (C) Copyright 2020 MaxMD Corporation, All Rights Reserved.
 *
 */
import React, {useState} from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import TableCell from "@mui/material/TableCell";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import {Avatar} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import {deepOrange, deepPurple, blue, cyan, green, indigo, pink, yellow} from "@mui/material/colors";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import clsx from 'clsx';
import {getKeyName, isMasterAdmin} from "../utils/portal-helper";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    small: {
        width: theme.spacing(3),
        height: theme.spacing(3),
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    deepOrange: {
        color: theme.palette.getContrastText(deepOrange[500]),
        backgroundColor: deepOrange[500],
    },
    blue: {
        color: theme.palette.getContrastText(blue[500]),
        backgroundColor: blue[500]
    },
    yellow: {
        color: theme.palette.getContrastText(yellow[700]),
        backgroundColor: yellow[700]
    },

    cyan: {
        color: theme.palette.getContrastText(cyan[900]),
        backgroundColor: cyan[900]
    },
    green: {
        color: theme.palette.getContrastText(green[900]),
        backgroundColor: green[900]
    },
    indigo: {
        color: theme.palette.getContrastText(indigo[500]),
        backgroundColor: indigo[500]
    },
    pink: {
        color: theme.palette.getContrastText(pink[500]),
        backgroundColor: pink[500]
    },
    deepPurple: {
        color: theme.palette.getContrastText(deepPurple[500]),
        backgroundColor: deepPurple[500],
    },

    menuItem: {
        minWidth: 300, marginBottom: 10
    },
    activeMenuItem: {
        backgroundColor: '#ddd'
    },
    menuItemText: {
        marginLeft: 10
    },
    chooseOrgButton: {
        marginLeft: 0, paddingLeft:0
    },
    avatarSmallText:{
        fontSize: '0.9rem'
    },
    avatarNormalText:{
        fontSize: '1.25rem'
    },
    orgNameButton: {
        '& span': {
            maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis'
        }
    }
}));

export default function ChooseOrganizationMenu(props) {
    const account = props.account;
    var availableOrganizations = [];
    if (account.organizations && account.organizations.length > 0){
        availableOrganizations = account.organizations;
    } else if (isMasterAdmin(account.user) && account.organization){
        availableOrganizations.push(account.organization);
    }


    const classes = useStyles();
    const handleSelectOrganization = props.handleSelectOrganization;

    const [anchorEl, setAnchorEl] = useState(null);
    const handleMenuClick = (e) => {
        setAnchorEl(e.currentTarget);
    }
    const handleMenuClose = () => {
        setAnchorEl(null);
    }

    const getAvatarClassName = (nameKey, index) => {
        // let colorCls;
        const colorList = [
            classes.deepOrange, classes.blue, classes.yellow, classes.cyan, classes.green, classes.indigo, classes.pink, classes.deepPurple
        ];
        const colorCls = colorList [ index % colorList.length ];
        // switch (index){
        //     case 0: colorCls = classes.deepOrange ; break;
        //     case 1: colorCls = classes.blue ; break;
        //     case 2: colorCls = classes.yellow ; break;
        //     case 3: colorCls = classes.cyan ; break;
        //     case 4: colorCls = classes.green ; break;
        //     case 5: colorCls = classes.indigo ; break;
        //     case 6: colorCls = classes.pink ; break;
        //     case 7: colorCls = classes.deepPurple ; break;
        // }
        let sizeCls;
        if (nameKey.length > 2){
            sizeCls = classes.avatarSmallText
        } else {
            sizeCls = classes.avatarNormalText;
        }
        return clsx(colorCls, sizeCls);
    }

    var selectedOrgIndex = -1;
    var selectedOrgKey = "";
    if (account && availableOrganizations && account.organization){
        availableOrganizations.map( (org, index) => {
            // console.log('looking for ' , account.organization.id , org);
            if (org.id === account.organization.id){
                selectedOrgIndex = index;
                // console.log(org.name);
                selectedOrgKey = getKeyName(org.name);
                // console.log('selectedOrgKey', selectedOrgKey);
            }
        });
    }
// console.log('selectedOrgIndex',  selectedOrgIndex);
// console.log('selectedOrgKey',  selectedOrgKey);
// console.log('availableOrganizations',  availableOrganizations);
    const ownerAdminName= account.server && account.server.owner && `${account.server.owner} Admin` || 'Admin';


    return (
        <div >
            {
                // selectedOrgKey && account.organizations.length === 1 && <>
                //     <ListItemIcon>
                //         <Avatar className={getAvatarClassName(selectedOrgKey, selectedOrgIndex)} >{selectedOrgKey}</Avatar>
                //     </ListItemIcon>
                //     <ListItemText primary={account.organization.name} /> <br/>
                // </>
            }
            {
                // isMasterAdmin(account.user) && <Button color='inherit' aria-controls="fade-menu" aria-haspopup="true"  className={classes.chooseOrgButton}>
                //     <ListItemIcon>
                //         <Avatar className={getAvatarClassName(ownerAdminName, 1)} >{getKeyName(ownerAdminName)}</Avatar>
                //     </ListItemIcon>
                //     <ListItemText className={classes.orgNameButton} primary={ownerAdminName} title={ownerAdminName} /> <br/>
                // </Button>
            }
            {
                selectedOrgKey && availableOrganizations.length > 0 && <div>
                    {availableOrganizations.length === 1 && <Button color='inherit' aria-controls="fade-menu" aria-haspopup="true"  className={classes.chooseOrgButton}>
                        <ListItemIcon>
                            <Avatar className={getAvatarClassName(selectedOrgKey, selectedOrgIndex)} >{selectedOrgKey}</Avatar>
                        </ListItemIcon>
                        <ListItemText className={classes.orgNameButton} primary={account.organization.name} title={account.organization.name} /> <br/>
                    </Button>}
                    {availableOrganizations.length > 1 && <Button color='inherit' aria-controls="fade-menu" aria-haspopup="true" onClick={handleMenuClick} className={classes.chooseOrgButton}>
                        <ListItemIcon>
                            <Avatar className={getAvatarClassName(selectedOrgKey, selectedOrgIndex)} >{selectedOrgKey}</Avatar>
                        </ListItemIcon>
                        <ListItemText  className={classes.orgNameButton} primary={account.organization.name} title={account.organization.name} /> <br/>
                        <ArrowDropDownIcon />
                    </Button>}

                    <Menu id={`choose-org-menu`} anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleMenuClose} >
                        <MenuItem disabled={true}>
                            <Typography variant="caption"> Choose Organization </Typography>
                        </MenuItem>
                        <Divider />
                        {availableOrganizations.map( (org, index) => {
                                var key = getKeyName(org.name);
                                var cls = getAvatarClassName(key, index);
                                return <MenuItem key={`org-menu-item-${index}`} onClick={()=> {
                                    handleMenuClose();
                                    handleSelectOrganization(org);
                                }} className={classes.menuItem} disabled={index === selectedOrgIndex}>
                                    <Avatar className={cls} >{key}</Avatar>
                                    <Typography variant="subtitle1" className={classes.menuItemText}> {org.name} </Typography>
                                </MenuItem>
                            }

                        )}

                        {/*<MenuItem onClick={handleMenuClose} className={classes.menuItem} disabled={true}>*/}
                        {/*    <Avatar className={`${classes.color1} `} >M</Avatar>*/}
                        {/*    <Typography variant="subtitle1" className={classes.menuItemText}>MaxMD </Typography>*/}
                        {/*</MenuItem>*/}
                        {/*<MenuItem onClick={handleMenuClose} className={classes.menuItem}>*/}
                        {/*    <Avatar className={`${classes.color2} `} >BH</Avatar>*/}
                        {/*    <Typography variant="subtitle1" className={classes.menuItemText}>Big Hospital </Typography>*/}
                        {/*</MenuItem>*/}
                        {/*<MenuItem onClick={handleMenuClose} className={classes.menuItem}>*/}
                        {/*    <Avatar className={`${classes.color3}`} classes={classes.avatarSmallText} >VVV</Avatar>*/}
                        {/*    <Typography variant="subtitle1" className={classes.menuItemText}> Very Very Very Long Long Long Organization Name!!!!!!!! </Typography>*/}
                        {/*</MenuItem>*/}
                        {/*<MenuItem onClick={handleMenuClose} className={classes.menuItem}>*/}
                        {/*    <Avatar className={`${classes.color4}`} >BH</Avatar>*/}
                        {/*    <Typography variant="subtitle1" className={classes.menuItemText}>Big Hospital </Typography>*/}
                        {/*</MenuItem>*/}
                        {/*<MenuItem onClick={handleMenuClose} className={classes.menuItem}>*/}
                        {/*    <Avatar className={`${classes.color5}`} >BH</Avatar>*/}
                        {/*    <Typography variant="subtitle1" className={classes.menuItemText}>Big Hospital </Typography>*/}
                        {/*</MenuItem>*/}
                        {/*<MenuItem onClick={handleMenuClose} className={classes.menuItem}>*/}
                        {/*    <Avatar className={`${classes.color6}`} >BH</Avatar>*/}
                        {/*    <Typography variant="subtitle1" className={classes.menuItemText}>Big Hospital </Typography>*/}
                        {/*</MenuItem>*/}
                        {/*<MenuItem onClick={handleMenuClose} className={classes.menuItem}>*/}
                        {/*    <Avatar className={`${classes.color7}`} >BH</Avatar>*/}
                        {/*    <Typography variant="subtitle1" className={classes.menuItemText}>Big Hospital </Typography>*/}
                        {/*</MenuItem>*/}
                        {/*<MenuItem onClick={handleMenuClose} className={classes.menuItem}>*/}
                        {/*    <Avatar className={`${classes.color8}`} >BH</Avatar>*/}
                        {/*    <Typography variant="subtitle1" className={classes.menuItemText}>Big Hospital </Typography>*/}
                        {/*</MenuItem>*/}
                    </Menu>
                </div>
            }

        </div>
    );

}
